<div class="col-sm-12 no-padding animated fadeIn">
    <h3>Listagem</h3>
    <hr>

    <div class="col-sm-12">
        <div class="col-sm-12 no-padding">
            <h4>Pesquisa:</h4>
            <div class="col-sm-2">
                <div class="ui-g-12 ui-fluid" style="padding: 0;">
                    <p-select name="status" [options]="status" [(ngModel)]="beneficiarioFiltro.status">
                    </p-select>
                </div>
            </div>
            <div class="col-sm-5">
                <input type="text" class="form-control" placeholder="Por nome"
                    [(ngModel)]="beneficiarioFiltro.atendidosProjeto.nome">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" mask="000.000.000-00" placeholder="Por CPF"
                    [(ngModel)]="beneficiarioFiltro.atendidosProjeto.cpf">
            </div>
            <div class="col-sm-2">
                <!-- // <button class="btn btn-primary btn-flat" (click)="pesquisar(); loading=false">Pesquisar</button>-->
                <button class="btn btn-primary btn-flat" (click)="pesquisar()">Pesquisar</button>                <div class="checkbox" style="margin-top: 8px;">
                    <label class="checkbox-inline">
                        <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                        Manter filtros selecionados
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="col-sm-12 no-padding">
        <hr>
    </div>

    <div class="col-sm-12 no-padding">
        <div *ngIf="!loading">
            <div class="spinner"></div>
            <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde
                ...
            </p>
        </div>

        <div *ngIf="loading">

            <div class="col-sm-12" *ngIf="beneficiarios.length == 0">
                <h4 class="text-center text-muted">Nenhum beneficiário encontrado para o filtro realizado</h4>
            </div>

            <div class="col-sm-12" *ngIf="beneficiarios.length > 0">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th>Nome</th>
                            <th class="text-center">CPF</th>
                            <th class="text-center">Status</th>
                            <th class="text-center"></th>
                            <th class="text-center">Ações</th>
                        </tr>
                        <tr *ngFor="let item of beneficiarios">
                            <td>{{item.atendidosProjeto.nome}}</td>
                            <td class="text-center">{{item.atendidosProjeto.cpf | mask: '000.000.000-00'}}</td>
                            <td class="text-center">
                                <ng-template [ngIf]="item.status">
                                    <b class="label label-success">ATIVO</b>
                                </ng-template>
                                <ng-template [ngIf]="!item.status">
                                    <b class="label label-danger">INATIVO</b>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <label class="switch">
                                    <input type="checkbox" (change)="alterarSatus($event, item)"
                                        [checked]="item.status">
                                    <span class="slider round"></span>
                                </label>
                            </td>
                            <td class="text-center">
                                <span class="badge bg-blue cursor" pTooltip="Visualizar todos os dados "
                                    tooltipPosition="top"
                                    (click)="openModalDadosBeneficiario(item.atendidosProjeto.id)"><i
                                        class="fa fa-fw fa-eye"></i></span>

                                <span class="badge bg-gray cursor" pTooltip="Editar" tooltipPosition="top"
                                    (click)="gotoBeneficiario(item.atendidosProjeto)">
                                    <i class="fas fa-pencil-alt"></i></span>

                                <span class="badge bg-red cursor" pTooltip="Excluir" tooltipPosition="top"
                                    (click)="confirmarExclusao(item)"><i class="fa fa-fw fa-trash"></i></span>

                                <a class="badge bg-light-blue cursor" pTooltip="Abrir modelo de arquivo"
                                    tooltipPosition="top" *ngIf="item.linkArquivo" href="{{item.linkArquivo}}"
                                    target="_blank"><i class="fas fa-external-link-alt"></i></a>

                                <span class="badge bg-gray cursor" pTooltip="Enviar documento" tooltipPosition="top"
                                    *ngIf="!item.hashFile" (click)="openModalUpload(item)"><i
                                        class="fa fa-fw fa-upload"></i></span>

                                <span class="badge bg-light-blue cursor" pTooltip="Visualizar" tooltipPosition="top"
                                    *ngIf="item.hashFile" (click)="openModalEditar(item)"><i
                                        class="fa fa-fw fa-file"></i></span>
                                 <span class="badge bg-light-blue cursor" pTooltip="Agenda" tooltipPosition="top"
                                             (click)="openModalAngenda(item.atendidosProjeto.id)"><i
                                                class="far fa-calendar"></i></span> 
                            </td>
                        </tr>
                    </tbody>
                </table>

                <pagination [page]="page" (paginationEvent)=changePage($event)></pagination>

            </div>

        </div>
    </div>

</div>
<!-- ================= MODAL AGENDA ================== -->

<p-dialog [(visible)]="modalAgenda" header="Agenda Beneficiário" width="900"
  showEffect="fade" [modal]="true">

  <h3><b>{{beneficiarioAgenda.nome}} </b></h3>
  <ul class="tree">
    <li><b class="text-muted">Data de Entrada:</b>
      <p style="margin-left: 12px; text-align: justify;"> 18/03/2020 </p>
    </li>
  </ul>
  <hr>
  <div class="col-sm-12 no-padding">
    <h4>Percentual da última informação cadastrada:
      <b class="text-light-blue">100%</b>
    </h4>
    <div class="progress" style="border-radius: 50px;">
      <div class="progress-bar progress-bar-primary" [style.width.%]="100">
      </div>
    </div>
  </div>

  <button class="btn btn-xs btn-default"  >
    <i class="fa fa-save"></i> &nbsp; Cadastrar nova informação</button>
  
  <br>
  <hr>

  <div class="col-sm-12 no-padding" >

    
    <h3 class="box-title" >
      <b>Informçãoes cadastradas</b>
    </h3>
    <div class="box-body table-responsive no-padding" >
      <table class="table table-condensed">
        <tbody>
          <tr>
            <th>Descricao</th>
            <th class="text-center">Progresso</th>
            <th class="text-center" style="width: 40px">Ação</th>
          </tr>
          <tr>
            <td>
              <div class="text-justify">
               Descrição teste 
              </div>
              <ul class="tree">
                <li ><a class="text-light-blue cursor"
                  ><b>Anexo
                      1 - Teste</b></a></li>
                <li><span class="text-muted">Cadastrado em: 10 de Março de 2020 - Por:
                    Leonardo</span></li>
              </ul>
            </td>
            <td class="text-center">
              <span class="badge bg-gray">100%</span>
            </td>
            <td class="text-center">
              <span class="badge bg-red cursor" >
                <i class="fa fa-fw fa-trash"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  

</p-dialog>


<!-- =================\. MODAL AGENDA ================ -->


<p-dialog [style]="{width: '900px'}" header="Dados do beneficiário" [(visible)]="modalBeneficiario"
    showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3 class="text-light-blue">{{beneficiario.nome}}</h3>
        <hr>
    </div>
    <div class="col-sm-6">
        <strong><i class="fa fa-book margin-r-5"></i>Informações</strong>
        <ul class="tree">
            <li>Nome da Mãe: <b>{{beneficiario.nomeMae}}</b></li>
            <li>Nome do Pai: <b>{{beneficiario.nomePai}} </b></li>
            <li>Estado Civil: <b>{{beneficiario.estadoCivil}}</b></li>
            <li>CPF: <b>{{beneficiario.cpf | mask: '000.000.000-00'}} </b></li>
            <li>RG: <b>{{beneficiario.rg}}</b></li>
            <li>Data de Nascimento: <b>{{beneficiario.dataNascimento | date: 'dd/MM/yyyy'}}</b></li>
            <li>Sexo: <b>{{beneficiario.sexo}}</b></li>
            <li>Naturalidade: <b>{{beneficiario.naturalidade}}</b></li>
            <li>Escolaridade: <b>{{verificaEscolaridade(beneficiario.escolaridade)}}</b></li>
            <li>Profissão: <b>{{beneficiario.profissao}} </b> </li>
        </ul>
    </div>
    <div class="col-sm-6">
        <strong><i class="fa fa-map-marker margin-r-5"></i> Endereço</strong>
        <ul class="tree">
            <li>Endereço, número: <b>{{beneficiario.endereco}}</b></li>
            <li>Bairro - CEP: <b>{{beneficiario.bairro}} - {{beneficiario.cep  | mask: '00.000-000' }}</b></li>
            <li>Cidade / Estado: <b>{{beneficiario.cidade}} / {{beneficiario.estado}}</b></li>
        </ul>
        <hr>
        <strong><i class="fa fa-bullhorn margin-r-5 margin-r-5"></i> Contato</strong>
        <ul class="tree">
            <li>Celular: <b>{{beneficiario.celular | mask: '(00) 0 0000-0000' }}</b></li>
            <li>Telefone Residencial: <b>{{beneficiario.telefoneResidencial | mask: '(00) 0 0000-0000' }}</b></li>
            <li>Telefone Comercial: <b>{{beneficiario.telefoneComercial | mask: '(00) 0 0000-0000' }}</b></li>
            <li>Email: <b>{{beneficiario.email}}</b></li>
        </ul>
    </div>
</p-dialog>


<p-dialog header="Upload" width="700" [(visible)]="displayOpenModalDocumento" showEffect="fade"
    [modal]="true">

    <div class="col-sm-12">
        <h3>Upload necessário para efetivar sua reposta.</h3>

        <button type="button" class="btn btn-success  btn-sm" (click)="adicionarArquivo(infoItem)"
            *ngIf="!displayOpenModalEditar">
            <i class="fa fa-fw fa-save"></i> Salvar
        </button>

        <button type="button" class="btn btn-success  btn-sm" (click)="alterarArquivo(infoItem)"
            *ngIf="displayOpenModalEditar">
            <i class="fa fa-fw fa-save"></i> Salvar alteração
        </button>

        <hr>
    </div>

    <div class="col-sm-12">
        <app-upload-service></app-upload-service>
        <hr>
    </div>

</p-dialog>



<p-dialog [style]="{width: '800px', 'min-height': '500px'}" header="Documento" [(visible)]="displayOpenModalEditar" showEffect="fade"
    [modal]="true">

    <div class="col-sm-12">
        <h3>Informações necessárias para visualizar ou alterar.</h3>
        <button type="button" class="btn btn-xs btn-default " (click)="displayOpenModalDocumento = true">
            Editar arquivo
        </button>
        <hr>
    </div>

    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>

        <div class="col-sm-12 text-center vcenter" *ngIf="!viewDownload">
            <br>
            <h4 class="text-muted">Para arquivos diferentes de PDF, é necessário efetuar o download.</h4>
            <br>
            <br>
            <button type="button" class="btn btn-sm btn-success " (click)="download()">
                <i class="fa fa-fw fa-download"></i> &nbsp;
                Efetuar download do arquivo
            </button>
        </div>

    </div>

</p-dialog>

<p-dialog [style]="{width: '800px', 'min-height': '500px'}" header="Documento" [(visible)]="displayOpenModalView" showEffect="fade"
    [modal]="true">
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>

